import React, { FC, ReactElement } from 'react';
import { Link } from 'react-router-dom';
import styles from './view-header.module.sass';
import { SearchV2 } from '../../views/search/SearchV2';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';

interface ILink {
    link: any;
    text: string;
    class?: string;
    icon?: any;
}

interface PropsType {
    title: string | ReactElement;
    subtitle?: string;
    links?: any;
    customAction?: any;
    breadcrumbs?: ReactElement;
    noUnderline?: boolean;
    backLink?: string | ReactElement;
    subtitlePadding?: boolean;
}

export const PublisherViewHeader: FC<PropsType> = (props) => {

    const linksArray: ReactElement[] = [];

    if (props.links) {

        props.links.forEach((link: ILink) => {

            linksArray.push(
                <Link key={link.text} to={link.link} className={link.class ? link.class : 'btn tbn-outline-secondary'}>
                    {link.icon ? link.icon : null} {link.text}
                </Link>
            );
        });
    }

    return (
        <Container fluid className={styles.stickyContainer}>
            <div className={styles.titleWrapper}>
                <h1 className={styles.title}>
                    {props.title}
                    {props.subtitle == undefined && props.subtitlePadding &&
                        <span className={styles.subtitlePadding}></span>}
                    {props.subtitle &&
                        <small className="text-capitalize">{props.subtitle}</small>}
                </h1>
                <Col xs="auto">
                    <div className={styles.actionsHeader}>
                        <SearchV2 />
                        {linksArray}
                        {props.customAction && props.customAction}
                    </div>
                </Col>
            </div>
        </Container>
    );
};
